import { branch, dining_table, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { nowISO } from "../utils/date-helpers";
import { patchRowVerified, type VerifiedWriteOptions } from "../powersync/verified-write";
import { generateId } from "@fleet/utils";

export async function createBranchMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  name: string,
  opts?: { address?: string; timezone?: string },
): Promise<string> {
  const id = generateId();
  const now = nowISO();
  await db.insert(branch).values({
    id,
    organization_id: organizationId,
    name: name.trim(),
    address: opts?.address ?? null,
    timezone: opts?.timezone ?? null,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export type TableStatus = "free" | "occupied" | "bill_requested";

export async function createTableMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  name: string,
  opts?: { seats?: number; sortOrder?: number },
): Promise<string> {
  const id = generateId();
  const now = nowISO();
  await db.insert(dining_table).values({
    id,
    organization_id: organizationId,
    branch_id: branchId,
    name: name.trim(),
    seats: opts?.seats ?? 2,
    status: "free",
    sort_order: opts?.sortOrder ?? 0,
    created_at: now,
    updated_at: now,
  });
  return id;
}

/**
 * Places (or repositions) a table in a cell of the dining-room floor plan.
 * `null` in both coordinates = remove it from the plan (return to auto-layout).
 */
export async function setTablePositionMutation(
  db: PowerSyncDrizzleDB,
  tableId: string,
  posX: number | null,
  posY: number | null,
  options?: VerifiedWriteOptions,
): Promise<void> {
  await patchRowVerified(
    db,
    dining_table,
    dining_table.id,
    tableId,
    {
      pos_x: posX === null ? null : Math.trunc(posX),
      pos_y: posY === null ? null : Math.trunc(posY),
    },
    options,
  );
}

export async function setTableStatusMutation(
  db: PowerSyncDrizzleDB,
  tableId: string,
  status: TableStatus,
  options?: VerifiedWriteOptions,
): Promise<void> {
  await patchRowVerified(db, dining_table, dining_table.id, tableId, { status }, options);
}
